// Exports
export default {
	"container": "container_E0T6E",
	"overlay": "overlay_LVfjP",
	"left": "left_1CgPD",
	"center": "center_OLfgF",
	"right": "right_7coQ0",
	"displayNameInputTitle": "displayNameInputTitle_5Qv42",
	"displayNameInput": "displayNameInput_RbQ6-",
	"joinMeetingButton": "joinMeetingButton_sZGSG",
	"recordOptionRecording": "recordOptionRecording_Tt-gz",
	"chatOption_container": "chatOption_container_6Es1V",
	"chatOption_badge": "chatOption_badge_3jLgb",
	"chatOption_badgeText": "chatOption_badgeText_0pCMN",
	"participantsOption": "participantsOption_QsVbP",
	"participantsOptionText": "participantsOptionText_gMIea",
	"separator": "separator_rnJ-X",
	"moreButtonPopoverWithOpenChat": "moreButtonPopoverWithOpenChat_AU8GG",
	"joined": "joined_WJ1Gq"
};
